export default __webpack_public_path__ + "static/media/hero_donut@3x.8e16fd61.png";